import { getWindowOrigin } from "@helper/utils";
import {
  ShareSocial as SharedShareSocial,
  type ShareSocialProps as SharedShareSocialProps,
} from "@sphtech/sph-web-ui/elements/ShareSocial";

export type {
  ShareSocialProps,
  SocialVariant,
} from "@sphtech/sph-web-ui/elements/ShareSocial";

type ShareSocialProps = Omit<SharedShareSocialProps, "baseUrl"> & {
  baseUrl?: string;
};

export default function ShareSocial({ baseUrl, ...props }: ShareSocialProps) {
  return (
    <SharedShareSocial {...props} baseUrl={baseUrl ?? getWindowOrigin()} />
  );
}
